export const IBV_LT = "ibu_lt";
export const ABV_GT = "abv_gt";


// WEBPACK FOOTER //
// ./src/components/containers/BeerDetails/beerOrder.js